import { gql } from "@apollo/client";

export const DELETE_SPACE = gql`
  mutation DeleteSpace($spaceMrn: ID!) {
    deleteSpace(spaceMrn: $spaceMrn)
  }
`;
